module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.$store.commit('toggleTheme')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("invert_colors")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t(_vm.isDarkTheme ? 'modo-dia' : 'modo-noche')))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7aa3d06e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/SelectTheme.vue
// module id = 1070
// module chunks = 1